import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import 'leaflet/dist/leaflet.css';


Vue.use(VueCookies,
  { 
    expires: '30d'
  }
)

Vue.use(VueAxios,axios)

// El token debe apuntar a la MISMA cuenta de Avanza que usa el chatbot; de lo
// contrario los cod_ofer que devuelve el chat no existen aquí y las fichas
// aparecen vacías. Configúralo con VUE_APP_AVANZA_TOKEN (.env / .env.production).
const AVANZA_TOKEN = process.env.VUE_APP_AVANZA_TOKEN || 'eyJpZCI6MTksInNlY3JldCI6Im5yM1lZRHdpeWMwWFpsUk5MZ0FxZGpsMk1oS0VSVmdZcjhja1l2N3VUS1ZNcHBOY2s4aUdlUEJhWGNVaSJ9'
axios.defaults.baseURL = process.env.VUE_APP_AVANZA_API || 'https://webservices-avanzainmuebles.xyz/api/'
axios.defaults.headers.common = {'Authorization': `Bearer ${AVANZA_TOKEN}`}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
